module.exports = __webpack_public_path__ + "media/submital_required_photos/rp_lateral_derecho-a40c9983.webp";